import { useRecoilValue } from 'recoil';
import { allAccounts } from 'store/app';

export function useAccounts() {
  const account = useRecoilValue(allAccounts);
  return account;
}
